import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Translate } from '../../../../../shared/LanguageService';
import { FirmProduct } from '../types';
import { ProductCard } from './ProductCard';

type SelectAdditionsStepProps = {
    additions: FirmProduct[];
    chosenAdditionIds: number[];
    onToggleAddition: (productId: number) => void;
};

export function SelectAdditionsStep({
    additions,
    chosenAdditionIds,
    onToggleAddition
}: SelectAdditionsStepProps) {
    if (additions.length === 0) {
        return <Typography>{Translate('order/create/v2/step/additions/none')}</Typography>;
    }

    return (
        <Box sx={{ display: 'grid', gap: '16px' }}>
            {additions.map((addition) => (
                <ProductCard
                    key={addition.id}
                    product={addition}
                    chosen={chosenAdditionIds.includes(addition.id)}
                    choice="many"
                    locked={addition.required}
                    onChoose={() => onToggleAddition(addition.id)}
                />
            ))}
        </Box>
    );
}
